export default __webpack_public_path__ + "static/media/organisation.71cd2cdd.svg";